import React from 'react';
import Select from '../../../../components/Select';
import Box from '../../../../components/Box';
import { API_ROOT } from '../../../../core/duck';
import { getPlayerHeight } from '../../../../utils';

export default class AddPlayerSelect extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Box className="hidden-print">
        <Select id="add-player"
                label="Add a player to the report:"
                placeholder="type name of player..."
                url={ `${API_ROOT}/v1/players/` }
                data={ params => ({ name: params.term }) }
                onSelect={ this.props.onSelect }
                optionTemplate={ player => {
                  if (player.loading) return player.text;
                  return (
                    `<div style="clear: left;">
                      <span style="display: block; float: left; margin-right: 20px;">
                        <img src="${ (player.profile_photo && player.profile_photo !== '') ? player.profile_photo
                                      : 'https://s3.amazonaws.com/s4usitesimages/images/anon-avatar.png' }"
                             alt="${player.last_name}"
                             style="height: 40px; width:30px;"
                             onerror="this.src='https://s3.amazonaws.com/s4usitesimages/images/anon-avatar.png'">
                      </span>
                      <div>
                        <div>${player.last_name} ${player.first_name}</div>
                        <div>
                          ${ player.position ? '<span style="margin-right: 20px">' + player.position.short_name + '</span>' : '' }
                          ${ player.height ? '<span style="margin-right: 20px">' + getPlayerHeight(player.height) + '</span>' : '' }
                          ${ player.main_nationality ? '<span style="margin-right: 20px">' + player.main_nationality.short_name + '</span>' : '' }
                          &nbsp;
                        </div>
                      </div>
                    </div>`
                  );
                }}
                selectionTemplate={ player => (
                  player.id ? `${player.last_name} ${player.first_name}` : player.text
                )}
                />
      </Box>
    );
  }
};



// WEBPACK FOOTER //
// ./src/features/scout-report/components/AddPlayerSelect/AddPlayerSelect.js